import { formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, catchError, finalize, of, switchMap, takeUntil, tap } from 'rxjs';
import { AccountService } from 'src/app/shared/services/account.service';
import { DataService } from 'src/app/shared/services/data.service';
import { TodayOrders } from '../models/today-orders';
import { PageEvent } from 'src/app/shared/directives/paginator.component';
import { DateTimeHelperService } from 'src/app/shared/services/date-time-helper.service';
import { faRotate, faReceipt } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-view-today-orders',
    templateUrl: './view-today-orders.component.html',
    styleUrls: ['./view-today-orders.component.scss'],
    standalone: false
})
export class ViewTodayOrdersComponent implements OnInit, OnDestroy {
  faRotate: any = faRotate;
  faReceipt: any = faReceipt;

  displayedColumns: string[] = ['accountId', 'orderId', 'symbol', 'priceLimit', 'quantity', 'side', 'type', 'status', 'ts'];
  private onDestroy$ = new Subject<void>();
  public loading: boolean = true;

  totalRecords = 0;
  pagedElements$: Observable<TodayOrders[]>;
  public todayOrders: TodayOrders[] = [];

  pageIndex = 0;
  pageSize = 25;
  searchExecuted = false;

  constructor(
    private data: DataService, 
    private accountService: AccountService,
    private dateTimeHelper: DateTimeHelperService) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.data.currentRiaId$
      .pipe(
        takeUntil(this.onDestroy$),
        switchMap(riaId =>
          this.accountService.getAllOrders(riaId, null)
          .pipe(
            tap((todayOrders: TodayOrders[]) => {
              console.log("Today orders:", todayOrders);
              this.todayOrders = todayOrders;
              this.totalRecords = todayOrders.length;
              this.getPagedData();
              this.searchExecuted = true;
            }),
            catchError(error => {
              console.error("Error fetching orders:", error);
              this.loading = false;
              this.searchExecuted = true; 
              return of([]);
            }),
            finalize(() => this.loading = false)
          )
        )
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  getPagedData(): void {
    this.pagedElements$ = of(this.todayOrders.slice(this.pageSize * this.pageIndex, (this.pageSize * this.pageIndex) + this.pageSize));
  }

  pageChangeEvent(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getPagedData();
  }

  parseDatetimeToEST(date: string){
    return this.dateTimeHelper.parseUtcStringToEstDateTimeString(date);
  }

  isToday(dateStr: string): boolean {
    const today = new Date();
    const todayStr = formatDate(today, 'yyyyMMdd', 'en-US');
    return dateStr === todayStr;
  }
}
